import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Radio,
  Typography,
  Paper,
  Popper,
  ClickAwayListener
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const users = [
  "Viewed but Never Started",
  "Started but Never Paid",
  "Multiple Failures",
  "Successful Only"
];

export default function UserFilterDropdown({ value, onChange }) {

  const [open, setOpen] = useState(false);
  const [internalSelected, setInternalSelected] = useState([]);

  const isControlled = Array.isArray(value) && typeof onChange === "function";
  const selected = isControlled ? value : internalSelected;

  const updateSelected = (next) => {
    if (isControlled) {
      onChange(next);
    } else {
      setInternalSelected(next);
    }
  };

  const anchorRef = useRef(null);

  const handleSelect = (item) => {
    if (selected.includes(item)) {
      updateSelected([]);
    } else {
      updateSelected([item]);
    }
  };

  const handleClear = () => {
    updateSelected([]);
  };

  const buttonLabel = () => {
    if (selected.length === 0) return "All User";
    if (selected.length === 1) return selected[0];
    return `${selected[0]} +${selected.length - 1}`;
  };

  return (
    <Box>

      {/* Button */}
      <Button
        ref={anchorRef}
        onClick={() => setOpen(!open)}
        variant="outlined"
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          textTransform: "none",
          borderRadius: "8px",
          height: "40px",
          width: "260px",
          border: "1px solid #E8E8E8",
          color: "#3E3E3E",
          justifyContent: "space-between"
        }}
      >
        {buttonLabel()}
      </Button>

      {/* Dropdown */}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        style={{ zIndex: 1300 }}
      >

        <ClickAwayListener onClickAway={() => setOpen(false)}>

          <Paper
            sx={{
              width: anchorRef.current?.clientWidth,
              mt: 1,
              p: 2,
              borderRadius: "12px"
            }}
          >

            {/* All Users (Clear Filter) */}
            <Box display="flex" alignItems="center" onClick={handleClear} sx={{ cursor: 'pointer', mb: 0.5 }}>
              <Radio
                checked={selected.length === 0}
                onChange={handleClear}
                size="small"
                sx={{
                  color: "#C4C4C4",
                  "&.Mui-checked": {
                    color: "#BE1F1F"
                  },
                  p: 0.5,
                  mr: 1
                }}
              />
              <Typography fontSize={14}>
                All Users
              </Typography>
            </Box>

            {/* List */}
            {users.map((item) => (

              <Box
                key={item}
                display="flex"
                alignItems="center"
                onClick={() => handleSelect(item)}
                sx={{ cursor: 'pointer', mb: 0.5 }}
              >
                <Radio
                  checked={selected.includes(item)}
                  onChange={() => handleSelect(item)}
                  size="small"
                  sx={{
                    color: "#C4C4C4",
                    "&.Mui-checked": {
                      color: "#BE1F1F"
                    },
                    p: 0.5,
                    mr: 1
                  }}
                />

                <Typography fontSize={14}>
                  {item}
                </Typography>

              </Box>

            ))}

          </Paper>

        </ClickAwayListener>

      </Popper>

    </Box>
  );
}